import { useInfiniteQuery } from 'react-query';

import { PendingAcknowledgement } from 'views/App/Portal/Policy/_types/acknowledgements';
import { ApiCollectionResponse } from 'types/api_response';
import {
  baseApiUrl,
  fetcher,
  infiniteEmptyResults,
  ServerErrorResponse,
  createParamString,
} from 'data_sources/constants';

export default function useUserPendingAcknowledgements<T extends PendingAcknowledgement>(
  userId: string,
  params = {},
  options: object = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const url = `${baseApiUrl()}/lexipub/acknowledgements/v1/admin/users/${userId}`;

  return useInfiniteQuery<ApiCollectionResponse<T>, ServerErrorResponse>(
    ['user_pending_acknowledgements', userId, params],
    async ({ pageParam, signal }): Promise<ApiCollectionResponse<T>> => {
      try {
        const paramString = createParamString(params);
        const data: ApiCollectionResponse<T> = await fetcher({
          method: 'get',
          url: pageParam || `${url}?${paramString}`,
          options: { signal },
        });

        return data;
      } catch (error: unknown) {
        if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
          onError(error as ServerErrorResponse);
        }
        throw error;
      }
    },
    {
      keepPreviousData: true,
      getNextPageParam: (lastPage) => {
        if (lastPage.offset && lastPage.offset < (lastPage.count || 0) && lastPage.content.length > 0) {
          const paramString = createParamString({
            ...params,
            offset: lastPage.offset,
          });
          return `${url}?${paramString}`;
        }
      },
      ...options,
    }
  );
}
